export default "__VITE_ASSET__CQ0SrpHa__"